import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      light: {
        primary: '#0F3058',
        secondary: '#4E4E4E',
        info: '#20212e',
        accent: '#76AACE',
        success: '#418f54',
        warning: '#bf7f1c',
        error: '#f44336',
      },
      dark: {
        primary: '#E1E1E1',
        secondary: '#4E4E4E',
        info: '#20212e',
        accent: '#76AACE',
        success: '#418f54',
        warning: '#bf7f1c',
        error: '#f44336',
      }
    },
  },
})